import {
  Component,
  ComponentFactoryResolver,
  ElementRef,
  Input,
  OnInit,
  ViewContainerRef,
} from '@angular/core';
import { RichTextComponent } from '~contentful/components/rich-text/rich-text.component';
import { ComponentModel } from '~contentful/models/components/component.model';
import { RichTextModel } from '~contentful/models/core/rich-text.model';

@Component({
  selector: 'app-contentful-renderer',
  templateUrl: './contentful-renderer.component.html',
})
export class ContentfulRendererComponent implements OnInit {
  @Input()
  public readonly model: ComponentModel | RichTextModel;

  constructor(
    private readonly componentFactoryResolver: ComponentFactoryResolver,
    private readonly viewContainerRef: ViewContainerRef,
    private readonly elementRef: ElementRef,
  ) {}

  ngOnInit() {
    if (this.model) {
      const component =
        this.model instanceof ComponentModel ? this.model.componentClass : RichTextComponent;
      const componentFactory = this.componentFactoryResolver.resolveComponentFactory(component);

      this.viewContainerRef.clear();

      const componentRef = this.viewContainerRef.createComponent(componentFactory);

      // @ts-ignore
      (<ContentfulComponent>componentRef.instance).model = this.model;
    }

    this.elementRef.nativeElement.remove();
  }
}
